import { Routes, Route } from "react-router-dom";
import GestionCobranza from "../pages/agent/GestionCobranza";
import GestionVenta from "../pages/agent/GestionVenta";
import Agente from "../pages/agent/Agente";
import RedirectComponent from "../pages/agent/Redirect";
import Login from "../pages/admin/Login";

const PublicRoutes = () => (
  <Routes>
          <Route path="/gestionCobranza" element={<GestionCobranza />} />
          <Route path="/gestionVenta" element={<GestionVenta />} />
          <Route path="/agente" element={<Agente />} />
          <Route path="/ucontact" element={<RedirectComponent />} />
          <Route path="/login" element={<Login />} />
  </Routes>
);

export default PublicRoutes;
